import type { PlaceholderDataFunction, QueryKey } from '@tanstack/react-query';

export type TeamIdSelector<TQueryKey extends QueryKey = QueryKey> = (
  queryKey?: TQueryKey
) => string | null | undefined;

const getDefaultTeamIdFromQueryKey: TeamIdSelector = (queryKey) => {
  if (!Array.isArray(queryKey) || queryKey.length < 1) return undefined;
  return queryKey[queryKey.length - 1] as string | null | undefined;
};

export const getTeamScopedPlaceholderData = <
  TQueryFnData,
  TError,
  TQueryData,
  TQueryKey extends QueryKey = QueryKey,
>(
  teamId: string | null | undefined,
  getTeamIdFromQueryKey: TeamIdSelector<TQueryKey> = getDefaultTeamIdFromQueryKey
): PlaceholderDataFunction<TQueryFnData, TError, TQueryData, TQueryKey> => {
  return (previousData, previousQuery) => {
    const previousTeamId = getTeamIdFromQueryKey(previousQuery?.queryKey);

    if (previousTeamId !== teamId) return undefined;

    return previousData;
  };
};
